<template>
  <div class="page find">
    <Header headTitle="지피테라퓨틱스" :isShowBackBtn="true" @clickBack="$router.push('/login')" />

    <div class="page-inner">
      <v-tabs fixed-tabs v-model="tab">
        <v-tab key="id"> 아이디 찾기 </v-tab>
        <v-tab key="pw"> 비밀번호 찾기 </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item key="id">
          <FindId />
        </v-tab-item>
        <v-tab-item key="pw" class="find-pw">
          <FindPassword />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Header from "../commonComp/WS-Header.vue";
import FindId from "./comp/findIdAndPassword/FindId.vue";
import FindPassword from "./comp/findIdAndPassword/FindPassword.vue";

const modelService = require("@/utils/dataModel.js");
const rulesService = require("@/utils/rules.js");
export default {
  components: {
    Header,
    FindId,
    FindPassword,
  },
  data() {
    return {
      tab: "",
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.find {
  &.page {
    height: 100vh;

    .page-inner {
      padding: 120px 30px 30px 30px;
      margin: 0 auto 2rem;
      height: calc(100% - 106px);
      position: relative;

      .v-btn:not(.v-btn--round).v-size--x-large {
        position: absolute;
        bottom: 0;
      }
    }
  }

  .v-window,
  .v-window__container {
    height: 100%;

  }


  .theme--light {
    &.v-tabs>.v-tabs-bar {
      border-radius: 24px;

      .v-ripple__container {
        display: none;
      }

      .v-tabs-slider-wrapper {
        height: 100% !important;

        .v-tabs-slider {
          border-radius: 24px;
        }
      }

      .v-tab {
        z-index: 100;

        &.v-tab--active {
          color: #ffffff;
        }
      }
    }

    &.v-tabs-items {
      background-color: transparent;

      .v-window-item {
        padding: 2rem 1rem;

        &.find-pw {
          padding: 2rem 0;
          height: 100%;
        }
      }
    }
  }
}

</style>
